import { Pipe, PipeTransform } from '@angular/core';
import { formatCompanyDateTime } from '../utils/company-date';

@Pipe({ name: 'companyDate' })
export class CompanyDatePipe implements PipeTransform {
  transform(value: string | number | Date | null | undefined): string {
    return formatCompanyDateTime(value);
  }
}
